// extracted by mini-css-extract-plugin
export var askAiIcon = "_nw-j";
export var category = "_nw-9";
export var categoryHeader = "_nw-e";
export var container = "_nw-0";
export var group = "_nw-a";
export var groupItems = "_nw-f";
export var groupSeparator = "_nw-k";
export var loading = "_nw-1";
export var noResults = "_nw-3";
export var placeholder = "_nw-2";
export var resultContent = "_nw-5";
export var resultIcon = "_nw-c";
export var resultItem = "_nw-g";
export var resultMeta = "_nw-8";
export var resultSubtitle = "_nw-7";
export var resultSuffix = "_nw-i";
export var resultTitle = "_nw-6";
export var resultsList = "_nw-4";
export var searchGroup = "_nw-d";
export var selected = "_nw-h";
export var subgroup = "_nw-b";